import { TFooterType } from '../types/footerType';

export const ALLOWED_FOOTER_TYPES: TFooterType[] = ['desktop', 'mobile', 'adaptive'];
export const MOBILE_FOOTER_TYPES: TFooterType[] = ['adaptive', 'mobile'];
